// btw-front/src/App.js
import React, { useEffect } from "react";
import { message } from "antd";
import AppRouter from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ResponsivePopup from "./components/Popup/ResponsivePopup";
import { PartnerSessionProvider } from "./context/PartnerSessionContext";
import RoleSwitcher from "./components/dev/RoleSwitcher";
import ScrollToTop from "./components/system/ScrollToTop";

export default function App() {
  // antd message 전역 위치 — sticky Navbar(약 64~80px) 아래 중앙 상단에 노출.
  // 디폴트 top=8px 이라 Navbar 에 가려져 안 보이는 문제 해결.
  // App 컴포넌트 마운트 시점에 1회만 호출 (모듈 import 부수 효과 회피 — SSR/테스트 격리).
  useEffect(() => {
    message.config({ top: 96, duration: 3, maxCount: 3 });
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <PartnerSessionProvider>
        <ScrollToTop />
        <AppRouter />
        <ResponsivePopup />
        <RoleSwitcher />
      </PartnerSessionProvider>
    </I18nextProvider>
  );
}
